import { Swiper, SwiperSlide } from 'swiper/react'
import { DialogListItem } from '../DialogListItem'
import { type ReactElement, useState } from 'react'
import type SwiperCore from 'swiper'
import { Autoplay, EffectFade } from 'swiper/modules'
import { TypeAnimatedChatDialogSkeleton } from '~/types/contentful'
import { Entry } from 'contentful'

// TODO: move this to a proper config file. career advice animation type.
type CareerAdviceAnimationProps = {
  data:
    | {
        blockId: string
        title?: string
        description?: string
        buttonName?: string
        buttonLink?: string
        chatDialogs?:
          | (
              | Entry<TypeAnimatedChatDialogSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', string>
              | undefined
            )[]
          | undefined
      }
    | undefined
}

export const CareerAdviceAnimation = ({ data }: CareerAdviceAnimationProps): ReactElement => {
  if (!data) return <></>

  const dialogs = data.chatDialogs?.map((item) => ({
    ...(item as Entry<TypeAnimatedChatDialogSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', string>).fields,
  }))
  const [, setActiveIndex] = useState<number>(0)
  const [swiper, setSwiper] = useState<SwiperCore | null>(null)

  return (
    <div
      className="career-advice__swiper-container"
      style={{ background: "url('./images/take_advice_bg.jpg') center / contain no-repeat" }}
    >
      <Swiper
        slidesPerView={1}
        speed={600}
        effect={'fade'}
        allowTouchMove={true}
        modules={[Autoplay, EffectFade]}
        fadeEffect={{
          crossFade: true,
        }}
        autoplay={{
          delay: 16000,
          disableOnInteraction: false,
        }}
        loop
        onSwiper={(s: SwiperCore) => {
          setSwiper(s)
        }}
        onSlideChange={(e) => {
          setActiveIndex(e.realIndex)
        }}
      >
        {dialogs?.map((dialog, index: number) => (
          <SwiperSlide key={index}>
            <DialogListItem dialog={dialog} idx={index} slider={swiper} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}
